<template>
    <div class="relative inline-block text-left">
        <div @click="open = !open">
            <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"
                ></path>
            </svg>
        </div>

        <!-- to close when clicked on space around it-->
        <button
            class="fixed inset-0 h-full w-full cursor-default focus:outline-none"
            v-if="open"
            @click="open = false"
            tabindex="-1"
        ></button>

        <transition
            enter-active-class="transition ease-out duration-100"
            enter-from-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
        >
            <!--            <div class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg" v-if="open">-->
            <div
                class="hidden md:block origin-top-left absolute left-0 mt-2 w-56 rounded-md shadow-lg z-10"
                v-if="open"
            >
                <div class="rounded-md bg-white ring-1 ring-black ring-opacity-5">
                    <div class="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                        <slot name="content"></slot>
                    </div>
                </div>
            </div>
        </transition>

        <!--dropdown content: mobile-->
        <transition
            enter-active-class="transition-all duration-200 ease-out"
            leave-active-class="transition-all duration-750 ease-in"
            enter-from-class="opacity-0 scale-75"
            enter-to-class="opacity-100 scale-100"
            leave-from-class="opacity-100 scale-100"
            leave-to-class="opacity-0 scale-75"
        >
            <div
                class="md:hidden fixed inset-x-0 bottom-0 bg-white w-full z-20 px-2 py-2 shadow-2xl leading-loose"
                v-if="open"
            >
                <slot name="content"></slot>
            </div>
        </transition>
        <!-- to close when clicked on space around it in mobile-->
        <div
            class="md:hidden fixed w-full h-full inset-0 bg-gray-900 opacity-50 z-10"
            @click="open = false"
            v-if="open"
        ></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            open: false,
        };
    },
    props: {
        avatar: {
            type: String,
            default: '',
        },
    },
    methods: {
        onEscape(e) {
            if (e.key === 'Esc' || e.key === 'Escape') {
                this.open = false;
            }
        },
    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.onEscape);
    },
    mounted() {
        document.addEventListener('keydown', this.onEscape);
    },
};
</script>
